<template>
  <div>
    <Header />
    <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
      <div class="bodyCenter">
        <div class="modalStyle">
          <div class="titulos">
            <div class="seccionTitle">
              <em class="fa fa-users mLeft"></em>
              <div class="headerTxt mLeft">Unificación de Pacientes</div>
            </div>
            <div class="alignIcon bold">Upx_unificacion</div>
          </div>
          <unificacion />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";

import unificacion from "../components/unificacionPacientes/unificacion.vue";

export default {
  name: "UnificacionPacientes_View",
  props: {
    msg: String,
  },
  components: {
    Header,
    unificacion,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),

  methods: {},
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
};
</script>

<style scoped>
</style>
